"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCalloutPopoverStyles = exports.Title = exports.TextContainer = exports.MediaContainer = exports.LinkButton = exports.IconAndTextContainer = exports.Footer = exports.Container = exports.Arrow = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _HBLinkButton = _interopRequireDefault(require("../HBLinkButton/HBLinkButton"));
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _ArrowRight = _interopRequireDefault(require("@honeybook/icons/dist/icons/ArrowRight16"));
var _breakpoints = require("../../styles/breakpoints");
var _HBText = _interopRequireDefault(require("../HBText/HBText"));
var getCalloutPopoverStyles = exports.getCalloutPopoverStyles = function getCalloutPopoverStyles(isUpToSmall) {
  return {
    neutral: {
      backgroundColor: _colors["default"].white,
      textColor: 'neutral900',
      primaryActionTheme: 'primary',
      secondaryActionTheme: isUpToSmall ? 'secondary-solid-secondary' : 'secondary-invisible-secondary',
      closeButtonTheme: 'dark',
      theme: 'calloutNeutral',
      LinkButtonTheme: 'neutral'
    },
    accent: {
      backgroundColor: _colors["default"].purple800,
      textColor: 'white',
      primaryActionTheme: 'secondary-solid-primary',
      secondaryActionTheme: 'secondary-translucent-secondary',
      closeButtonTheme: 'light',
      theme: 'calloutAccent',
      LinkButtonTheme: 'link-button-accent'
    }
  };
};
var MediaContainer = exports.MediaContainer = _styledComponents["default"].div.withConfig({
  displayName: "HBCalloutPopoverstyles__MediaContainer",
  componentId: "sc-d03qo9-0"
})(["max-width:380px;> *{display:flex;}"]);
var Container = exports.Container = _styledComponents["default"].div.withConfig({
  displayName: "HBCalloutPopoverstyles__Container",
  componentId: "sc-d03qo9-1"
})(["display:flex;flex-direction:column;gap:16px;"]);
var IconAndTextContainer = exports.IconAndTextContainer = _styledComponents["default"].div.withConfig({
  displayName: "HBCalloutPopoverstyles__IconAndTextContainer",
  componentId: "sc-d03qo9-2"
})(["display:flex;flex-direction:row;gap:8px;min-width:200px;max-width:380px;"]);
var TextContainer = exports.TextContainer = _styledComponents["default"].div.withConfig({
  displayName: "HBCalloutPopoverstyles__TextContainer",
  componentId: "sc-d03qo9-3"
})(["display:flex;flex-direction:column;gap:4px;", "{gap:16px;}"], _breakpoints.upToSmall);
var Footer = exports.Footer = _styledComponents["default"].div.withConfig({
  displayName: "HBCalloutPopoverstyles__Footer",
  componentId: "sc-d03qo9-4"
})(["display:flex;flex-direction:column;flex-wrap:wrap;align-content:flex-end;margin-top:-4px;"]);
var Arrow = exports.Arrow = (0, _styledComponents["default"])(_ArrowRight["default"]).withConfig({
  displayName: "HBCalloutPopoverstyles__Arrow",
  componentId: "sc-d03qo9-5"
})(["margin-left:-6px;line-height:0;display:block;"]);
var LinkButton = exports.LinkButton = (0, _styledComponents["default"])(_HBLinkButton["default"]).withConfig({
  displayName: "HBCalloutPopoverstyles__LinkButton",
  componentId: "sc-d03qo9-6"
})(["height:18px;"]);
var Title = exports.Title = (0, _styledComponents["default"])(_HBText["default"]).withConfig({
  displayName: "HBCalloutPopoverstyles__Title",
  componentId: "sc-d03qo9-7"
})(["padding-right:20px;"]);
//# sourceMappingURL=HBCalloutPopover.styles.js.map